export var EventState;
(function (EventState) {
    EventState[EventState["IDLE"] = 0] = "IDLE";
    EventState[EventState["REPOSITIONING"] = 1] = "REPOSITIONING";
    EventState[EventState["RESIZING"] = 2] = "RESIZING";
})(EventState || (EventState = {}));
